<template>
  <form class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
    <div class="wrapper input-group">
      <input type="text" id="searchSystem" class="form-control bg-light border-0 autocomplete-input small"
        placeholder="Pesquisar no sistema..." aria-label="Search" aria-describedby="basic-addon2" @keydown="search"
        v-model="searchInput">
      <ul class="autocomplete-list">
        <li class="list-item pointer" v-for="(result, index) in results" :key="index"
          @click="toModule(result.id, result.model, result)">
          {{ result.model }} - {{ result.name }}
        </li>
      </ul>
      <div class="input-group-append">
        <button class="btn btn-light" type="button" @click="resetSearch()">
          <i class="fas fa-trash fa-sm"></i> Limpar pesquisa
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';

export default {
  props: ['list'],
  data() {
    return {
      searchInput: '',
      results: []
    }
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value)
    },


    search() {
      if (this.searchInput.length >= 2) {
        this.results = {};
        api.get('/search', {
          params: {
            'query': this.searchInput
          }
        })
          .then((response) => {
            this.results = response.data.original.categories
              .concat(response.data.original.services)
              .concat(response.data.original.suppliers)
              .concat(response.data.original.clients)
              .concat(response.data.original.leads);
            this.results.forEach(item => {
              if (this.results.includes(item.name)) {
                this.results.push({
                  'id': item.id,
                  'name': item.name,
                  'model': item.model
                })
              }

            });
          }).catch(error => {
            handleRequestErrors(error)

          })
      }
    },

    resetSearch() {
      this.results = {};
      this.searchInput = '';
    },

    toModule(id, module_selected, object) {

      if (module_selected == 'Categorias') {
        this.resetSearch();
        this.$router.push({
          name: 'category_edit',
          params: { id: id }
        });
      } else if (module_selected == 'Serviços') {
        this.resetSearch();
        this.$router.push({
          name: 'service_edit',
          params: { id: id }
        });
      } else if (module_selected == 'Fornecedores') {
        this.resetSearch();
        this.$router.push({
          name: 'supplier_edit',
          params: { id: id }
        });
      } else if (module_selected == 'Clientes') {
        this.resetSearch();
        if (object.type == 'pf') {
          this.$router.push({
            name: 'client_pf_edit',
            params: { id: id }
          });
        } else {

          this.$router.push({
            name: 'client_pj_edit',
            params: { id: id }
          });
        }

      }else if (module_selected == 'Leads') {
        this.resetSearch();
        this.$router.push({
          name: 'lead_edit',
          params: { id: id }
        });
      } 
    }
  }
}

</script>

<style>
/*the container must be positioned relative:*/
@import url(https://fonts.googleapis.com/css?family=Roboto);


.autocomplete-list {
  position: absolute;
  list-style-type: none;
  background: #fff;
  width: 100%;
  margin-top: 50px;
  box-shadow: 0 0 10px #ddd;
  background: #e9e9e9;
  transition: all 300ms ease-out;
  transform: scale(1) translateY(0);
  transform-origin: center center;
  z-index: 99999;
  max-height: 300px;
  overflow-y: auto;
}

.list-item {
  padding: 10px;
  border-top: 1px solid #0000001f;
  background: #e9e9e9;
}

.list-item:hover {
  background: #d8d8d8;
}

.pointer {
  cursor: pointer;
}
</style>